import { render, staticRenderFns } from "./PerformanceTabs.vue?vue&type=template&id=da6d74ae&scoped=true"
import script from "./PerformanceTabs.vue?vue&type=script&lang=js"
export * from "./PerformanceTabs.vue?vue&type=script&lang=js"
import style0 from "./PerformanceTabs.vue?vue&type=style&index=0&id=da6d74ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da6d74ae",
  null
  
)

export default component.exports